import { PayoutBatchStatus } from '@fluenceur/types';
import { parseAsStringEnum } from 'nuqs';

/**
 * The payout list's status filter lives in the address, so a link can open the
 * list already narrowed. Prefixed because the history tab of the same page
 * already reads `status` for a commission status, and the two must not answer
 * each other when the brand switches tabs.
 */
export const PAYOUT_STATUS_PARAM = 'payoutStatus';

/** An unknown value in the address reads as no filter rather than as an error. */
export const payoutStatusParser = parseAsStringEnum<PayoutBatchStatus>(
  Object.values(PayoutBatchStatus)
);

/** The payouts the brand can still finish: drafts are the resumable ones. */
export const UNFINISHED_PAYOUTS_HREF = `/payments/commissions?tab=payouts&${PAYOUT_STATUS_PARAM}=${PayoutBatchStatus.DRAFT}`;
